import React, { useState } from 'react'
import { Button, List, Tooltip } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { EyeOutlined } from '@ant-design/icons'
import { PublicationUrl } from 'src/core/models'
import Image, { StaticImageData } from 'next/image'
import styles from './PublicationUrlsList.module.scss'
import { CustomLink, CustomIframe, CustomModal } from 'src/components'
import { getFirstSubstring, isSafari, languages } from 'src/core/helpers'

const PublicationUrlsList: React.FC<{ publicationUrls: PublicationUrl[] }> = (props) => {
  const { publicationUrls } = props
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const [selectedUrl, setSelectedUrl] = useState(null)
  const { isMobile } = useWindowSize()

  const getFlag = (url: PublicationUrl): StaticImageData => {
    return languages.find(l => l.value === url.language)?.src
  }

  return (
    <div className={'collapse-animation'}>
      <List
        itemLayout='horizontal'
        dataSource={publicationUrls}
        renderItem={(item: PublicationUrl) => (
          <List.Item>
            <List.Item.Meta
              title={
                <div className={styles.content}>
                  <Image
                    src={getFlag(item)}
                    alt={`Flag ${item.language}`}
                    width={25}
                    height={25}
                    objectFit='contain'
                    className={styles.flag}
                  />
                  <CustomLink
                    label={`${getFirstSubstring(item.url, isMobile ? 30 : 100)}...`}
                    link={item.url}
                    target='_blank'
                    showIcon={false}
                    isSmallText
                  />
                </div>
              }
            />
            {(!isSafari() && !isMobile) && (
              <Tooltip color='blue' title={t('Publications.Preview')}>
                <Button
                  type='ghost'
                  size='middle'
                  shape='circle'
                  icon={<EyeOutlined />}
                  className='radius-100 mr-3 mb-2'
                  onClick={() => {
                    setIsModalVisible(true)
                    setSelectedUrl(item.url)
                  }}
                />
              </Tooltip>
            )}
          </List.Item>
        )}
      />
      <CustomModal
        width={1400}
        footer={null}
        open={isModalVisible}
        title={t('Publications.Preview')}
        onCancel={() => {
          setIsModalVisible(false)
          setSelectedUrl(null)
        }}
      >
        <CustomIframe src={selectedUrl} />
      </CustomModal>
    </div>
  )
}

export default PublicationUrlsList
